/**
 * @flow
 * @relayHash cfe61f0d4cd28efd99c197882b5e67d5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProductSummary_product$ref = any;
export type ProductsQueryVariables = {| |};
export type ProductsQueryResponse = {|
  +allCategories: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +name: ?string,
        +products: {|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +name: string,
              +$fragmentRefs: ProductSummary_product$ref,
            |},
          |}>,
        |},
        +family: ?{|
          +name: string,
        |},
      |},
    |}>,
  |},
|};
*/


/*
query ProductsQuery {
  allCategories {
    edges {
      node {
        name
        products {
          edges {
            node {
              name
              ...ProductSummary_product
              id
            }
          }
        }
        family {
          name
          id
        }
        id
      }
    }
  }
}

fragment ProductSummary_product on Product {
  ...ProductSummaryContent_product
}

fragment ProductSummaryContent_product on Product {
  id
  name
  description
  files {
    edges {
      node {
        url
      }
    }
  }
  category {
    name
    family {
      name
      id
    }
    id
  }
  ...ProductCharacteristics_product
}

fragment ProductCharacteristics_product on Product {
  category {
    characteristicKeys {
      edges {
        node {
          key
          id
        }
      }
    }
    id
  }
  characteristics {
    edges {
      node {
        key {
          key
          id
        }
        value
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "family",
  "storageKey": null,
  "args": null,
  "concreteType": "Family",
  "plural": false,
  "selections": [
    v0,
    v1
  ]
},
v3 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "key",
    "args": null,
    "storageKey": null
  },
  v1
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "ProductsQuery",
  "id": null,
  "text": "query ProductsQuery {\n  allCategories {\n    edges {\n      node {\n        name\n        products {\n          edges {\n            node {\n              name\n              ...ProductSummary_product\n              id\n            }\n          }\n        }\n        family {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ProductSummary_product on Product {\n  ...ProductSummaryContent_product\n}\n\nfragment ProductSummaryContent_product on Product {\n  id\n  name\n  description\n  files {\n    edges {\n      node {\n        url\n      }\n    }\n  }\n  category {\n    name\n    family {\n      name\n      id\n    }\n    id\n  }\n  ...ProductCharacteristics_product\n}\n\nfragment ProductCharacteristics_product on Product {\n  category {\n    characteristicKeys {\n      edges {\n        node {\n          key\n          id\n        }\n      }\n    }\n    id\n  }\n  characteristics {\n    edges {\n      node {\n        key {\n          key\n          id\n        }\n        value\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ProductsQuery",
    "type": "LarkSeedsAPI",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allCategories",
        "storageKey": null,
        "args": null,
        "concreteType": "CategoryConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Category",
                "plural": false,
                "selections": [
                  v0,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProductConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": false,
                            "selections": [
                              v0,
                              {
                                "kind": "FragmentSpread",
                                "name": "ProductSummary_product",
                                "args": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "family",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Family",
                    "plural": false,
                    "selections": [
                      v0
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProductsQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allCategories",
        "storageKey": null,
        "args": null,
        "concreteType": "CategoryConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Category",
                "plural": false,
                "selections": [
                  v0,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "products",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProductConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Product",
                            "plural": false,
                            "selections": [
                              v0,
                              v1,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "description",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "files",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FileConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FileEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "url",
                                            "args": null,
                                            "storageKey": null
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "category",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Category",
                                "plural": false,
                                "selections": [
                                  v0,
                                  v2,
                                  v1,
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "characteristicKeys",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CharacteristicKeyConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "CharacteristicKeyEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CharacteristicKey",
                                            "plural": false,
                                            "selections": v3
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "characteristics",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CharacteristicValueConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CharacteristicValueEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "CharacteristicValue",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "key",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "CharacteristicKey",
                                            "plural": false,
                                            "selections": v3
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "value",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          v1
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  v2,
                  v1
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '31c06e974a032d50493120ae07cc2e8b';
module.exports = node;



// WEBPACK FOOTER //
// ./src/views/Products/__generated__/ProductsQuery.graphql.js